import { useMemo } from 'react'
import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import hashActions from '../actions/hash'

export const useHash = () => {
  const data = useSelector((state) => {
    return get(state, 'app.hashManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(hashActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
